import * as actionTypes from './actionTypes';
import * as baseAction from './baseAction';

import { sanitizePhoneNumber } from '../../lib/Sanitizer';
import { formatPhoneNumber } from '../../lib/Formatter';

export const franchiseProductTemplateStart = (accessToken, data) => baseAction.actionStart(actionTypes.FRANCHISEPRODUCTTEMPLATE_START, accessToken, data);
export const franchiseProductTemplateSuccess = (data) => baseAction.actionSuccess(actionTypes.FRANCHISEPRODUCTTEMPLATE_SUCCESS, data);
export const franchiseProductTemplateFail = (error) => baseAction.actionFail(actionTypes.FRANCHISEPRODUCTTEMPLATE_FAIL, error);

export const franchiseProductTemplateSelect = (options) => {
    return (dispatch, getState) => {  
        if (options && options.franchiseProductId) {
            baseAction.actionExecute(dispatch, getState, {
                url: `/FranchiseProductsTemplates/${options.franchiseProductId}`,
                startFn: (accessToken) => dispatch(franchiseProductTemplateStart(accessToken, { lastScope: 'select' })),
                successFn: (response) => dispatch(franchiseProductTemplateSuccess({ franchiseProduct: formatData(response.data), isNew: false })),
                failFn: (error) => dispatch(franchiseProductTemplateFail(error))
            });
        } else {
            dispatch(franchiseProductTemplateSuccess({ franchiseProduct: null, isNew: true }));
        }
    };
};

export const franchiseProductTemplateList = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            url: `/FranchiseProductsTemplates/Franchise/${options.franchiseId}`,
            startFn: (accessToken) => dispatch(franchiseProductTemplateStart(accessToken, { lastScope: 'list' })),
            successFn: (response) => dispatch(franchiseProductTemplateSuccess({ franchiseProducts: response.data })),
            failFn: (error) => dispatch(franchiseProductTemplateFail(error))
        });
    };
};

export const franchiseProductTemplateBaseList = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            url: `/FranchiseProductsTemplates`,
            startFn: (accessToken) => dispatch(franchiseProductTemplateStart(accessToken, { lastScope: 'list' })),
            successFn: (response) => dispatch(franchiseProductTemplateSuccess({ franchiseProducts: response.data })),
            failFn: (error) => dispatch(franchiseProductTemplateFail(error))
        });
    };
};

export const franchiseProductTemplateCreate = (options) => {
    return (dispatch, getState) => {
        const product = createProduct(options.data);
        baseAction.actionExecute(dispatch, getState, {
            type: 'create',
            url: `/FranchiseProductsTemplates/Product/${options.productId}/${options.name}/${options.productTypeId}`,
            payload: sanitizeData(product),
            startFn: (accessToken) => dispatch(franchiseProductTemplateStart(accessToken, { lastScope: 'create' })),
            successFn: (response) => dispatch(franchiseProductTemplateSuccess({ franchiseProduct: formatData(response.data), isNew: false })),
            failFn: (error) => dispatch(franchiseProductTemplateFail(error))
        });
    };
};

export const franchiseProductTemplateUpdate = (options) => {
    return (dispatch, getState) => {
        const product = createProduct(options.data);
         let { file } = options.data;
        baseAction.actionExecute(dispatch, getState, {
            type: 'update',
            multiPart: true,
            files: [file],
            url: `/FranchiseProductsTemplates/${options.franchiseProductId}`,
            payload: product,
            startFn: (accessToken) => dispatch(franchiseProductTemplateStart(accessToken, { lastScope: 'update' })),
            successFn: (response) => dispatch(franchiseProductTemplateSuccess({ franchiseProduct: formatData(response.data), isNew: false })),
            failFn: (error) => dispatch(franchiseProductTemplateFail(error))
        });
    };
};

export const franchiseProductTemplateDelete = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'delete',
            url: `/FranchiseProductsTemplates/${options.franchiseProductId}`,
            startFn: (accessToken) => dispatch(franchiseProductTemplateStart(accessToken, { lastScope: 'delete' })),
            successFn: () => dispatch(franchiseProductTemplateSuccess({ franchiseProduct: null, isNew: false })),
            failFn: (error) => dispatch(franchiseProductTemplateFail(error))      
        });
    };
};

export const franchiseProductTemplateAssign = (options) => {
    return (dispatch, getState) => {
        baseAction.actionExecute(dispatch, getState, {
            type: 'post',
            url: `/FranchiseProductsTemplates/Product/${options.productId}/${options.name}/${options.productTypeId}`,
            startFn: (accessToken) => dispatch(franchiseProductTemplateStart(accessToken, { lastScope: 'assign' })),
            successFn: (response) => dispatch(franchiseProductTemplateSuccess({ franchiseProduct: formatData(response.data), isNew: false })),
            failFn: (error) => dispatch(franchiseProductTemplateFail(error))      
        })
    };
};

export const franchiseProductTemplateReset = () => {
    return {
        type: actionTypes.FRANCHISEPRODUCTTEMPLATE_RESET,
        data: {
            franchiseProduct: null,
            isNew: false
        }
    };
};

const formatData = (value) => {
    if (value) {
        if (value.contactPhoneNumber) {
            value.contactPhoneNumber = formatPhoneNumber(value.contactPhoneNumber);
        }

        if (value.recruitingPhoneNumber) {
            value.recruitingPhoneNumber = formatPhoneNumber(value.recruitingPhoneNumber);
        }
    }

    return value;
};

const sanitizeData = (value) => {
    if (value) {
        value.contactPhoneNumber = (value.contactPhoneNumber) && sanitizePhoneNumber(value.contactPhoneNumber);
        value.recruitingPhoneNumber = (value.recruitingPhoneNumber) && sanitizePhoneNumber(value.recruitingPhoneNumber);

        if (value.twilioPhoneNumber) {
            const phoneNumbers = value.twilioPhoneNumber.split(',');

            const newNumbers = phoneNumbers.map((phoneNumber) => {
                return sanitizePhoneNumber(phoneNumber);
            });

            value.twilioPhoneNumber = newNumbers.join(',');
        }
    }

    return value;
};

const createProduct = (value) => {
    const { allow_display_name, allow_utf8_local_part, require_display_name, require_tld, ...data} = value;
    let { applyFees, productTypeId, name, assignedFranchises, activatedFranchises, description, imageFilename, ...productData } = data;
    return {
        applyFees: applyFees || false,
        productTypeId: productTypeId,
        name: name,
        activatedFranchises: activatedFranchises || [],
        assignedFranchises: assignedFranchises || [],
        productData: JSON.stringify(productData),
        description,
        imageFilename
    };
};
